import { render, staticRenderFns } from "./PraticaTransitarioDoganale.vue?vue&type=template&id=1e1c5ede&scoped=true&"
import script from "./PraticaTransitarioDoganale.vue?vue&type=script&lang=js&"
export * from "./PraticaTransitarioDoganale.vue?vue&type=script&lang=js&"
import style0 from "./PraticaTransitarioDoganale.vue?vue&type=style&index=0&id=1e1c5ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c5ede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1c5ede')) {
      api.createRecord('1e1c5ede', component.options)
    } else {
      api.reload('1e1c5ede', component.options)
    }
    module.hot.accept("./PraticaTransitarioDoganale.vue?vue&type=template&id=1e1c5ede&scoped=true&", function () {
      api.rerender('1e1c5ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaTransitarioDoganale.vue"
export default component.exports